var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "contain"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.show
    }
  }, [_vm._v("演示")]), _vm._v(" "), _c('p', [_vm._v("\n            结果：" + _vm._s(_vm.result) + "\n        ")])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('h1', [_vm._v("vuejs-modal")]), _vm._v(" "), _c('a', {
    staticClass: "github",
    attrs: {
      "href": "https://github.com/shaodahong/vuejs-modal",
      "target": "_blank"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2220e576","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = Dk48
// module chunks = 1